import { all, takeEvery, put, fork } from "redux-saga/effects";

import axios from "./initialize";
import {
  GET_APP_EMAIL_TEMPLATE_LIST,
  ADD_APP_EMAIL_TEMPLATE,
  DELETE_APP_EMAIL_TEMPLATE,
  UPDATE_APP_EMAIL_TEMPLATE,
  GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST,
  ADD_APP_INSTANCE_EMAIL_TEMPLATE,
  DELETE_APP_INSTANCE_EMAIL_TEMPLATE,
  UPDATE_APP_INSTANCE_EMAIL_TEMPLATE,
} from "redux/constants/template";

import {
    instanceTemplates,
  showTemplateMessage,templates,setAddEdit
} from "redux/actions/template";
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { Modal } from "antd";
import { t } from "i18next";
import { CheckCircleFilled} from '@ant-design/icons';


export function* getAppEmailTemplateList() {
  yield takeEvery(GET_APP_EMAIL_TEMPLATE_LIST, function* ({ payload }) {
    const {query,appId} = payload;
    const accountId = localStorage.getItem("accountId");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const response = yield axios.get(
        `${API_BASE_URL}/manage/app-template?accountId=${accountId}&appId=${appId}&query=${
          query
        }&sortfield=${payload?.sorter?.field}&sortorder=${
            payload?.sorter?.order
        }&page=${payload?.pagination?.current - 1}&size=${
            payload?.pagination?.pageSize
        }`,
        config
      );
      if (response.status === 200) {
        if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_email_templatees`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and Keyword=${payload?.query}`,
                status: `email templates retrieve successfully `,
                action: `Search get ${payload?.type}s`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
			}else{
            const traceObj ={
                type: `get_email_templates`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId}`,
                status: `${response?.type}s retrieve successfully `,
                action: `clicked get emial templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
			}		
        yield put(templates(response.data));
      }
    } catch (err) {
            if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_email_templates`,
                event: 'click',
                message: `0 results found for keyword=${payload?.query} and accountId=${accountId}`,
                status: `Failed to retrieve email templates`,
                action: `Search tp get email templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }else{
                const traceObj ={
                type: `get_email_templates`,
                event: 'click',
                message: `0 results found for accountId=${accountId}`,
                status: `Failed to retrieve email templates`,
                action: `clicked get email templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }
            console.log(err);
            yield put(showTemplateMessage(err?.response));
    }
  });
}

export function* addAddAppEmailTemplate() {
    yield takeEvery(ADD_APP_EMAIL_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const {appId,query}=payload;
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.post(
          `${API_BASE_URL}/manage/app-template`,
          payload,
          config
        );
        if (res.status === 201) {
          const traceObj ={
            type: `add_email_template`,
            event: 'click',
            message: `App email template added successfully  for name=${payload?.name}`,
            status: `App email template added successfully `,
            action: `Clicked email template to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
            const response = yield axios.get(
                `${API_BASE_URL}/manage/app-template?accountId=${accountId}&appId=${appId}&query=${
                  query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                    payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                    payload?.pagination?.pageSize
                }`,
                config
              );
              if (response.status === 200) {
                Modal.success({
                  title: t("impaqx.adminApp.appEmailTemplateSuccessMessage"),
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(templates(response.data));
                yield put(setAddEdit(false));
              }
            }
      } catch (err) {
        const traceObj ={
          type: `add_email_template`,
          event: 'click',
          message: ` Failed to add email template name=${payload?.name}`,
          status: `Failed to add email template`,
          action: `Clicked email template to add`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(err);
        yield put(showTemplateMessage(err?.response));
      }
    });
  }
  
  export function* deleteAppEmailTemplate() {
    yield takeEvery(DELETE_APP_EMAIL_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.delete(
          `${API_BASE_URL}/manage/app-template/${payload?.id}`,
          config
        );
        if (res.status === 200) {
          const traceObj ={
            type: `delete_email_template`,
            event: 'click',
            message: `email template deleted for id=${payload?.id}`,
            status: `email template deleted`,
            action: `Clicked delete email template`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          //yield put(showAccountMessage(res));
          const response = yield axios.get(
            `${API_BASE_URL}/manage/app-template?accountId=${accountId}&appId=${payload?.appId}&query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
             Modal.success({
              title: `${payload.name} ${t("impaqx.adminApp.appEmailTemplateDeleteMessage")}`,
              icon: <CheckCircleFilled />,
              okText: "Close",
              //cancelText: 'Cancel',
              onOk() {
                //deleteApp(id);
              },
            });
            yield put(templates(response.data));
          }
        }
      } catch (error) {
        const traceObj ={
          type: `delete_email_template`,
          event: 'click',
          message: `Failed to delete email template id=${payload.id}`,
          status: `Failed to delete email template`,
          action: `Clicked to delete email template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        yield put(showTemplateMessage(error?.response));
      }
    });
  }

  export function* updateAppEmailTemplate() {
    yield takeEvery(UPDATE_APP_EMAIL_TEMPLATE, function* ({ payload }) {
      const appEmailTemplate=payload;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      try {
        const res = yield axios.put(
          `${API_BASE_URL}/manage/app-template/${appEmailTemplate?.id}`,
          appEmailTemplate,
          config
        );
        if (res.status === 200) {
          const traceObj ={
              type: `update_email_template`,
              event: 'click',
              message: `email template updated for id=${payload.id}`,
              status: `email template updated`,
              action: `Clicked to update email template`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
          const response = yield axios.get(
            `${API_BASE_URL}/manage/app-template?accountId=${appEmailTemplate?.accountId}&appId=${appEmailTemplate?.appId}&query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
            Modal.success({
                title: t("impaqx.adminApp.templateUpdateMessage"),
                icon: <CheckCircleFilled />,
                okText:t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            yield put(templates(response.data));
            yield put(setAddEdit(false));
          }
        //   yield put(showTemplateMessage(res));
        }
      } catch (error) {
        const traceObj ={
          type: `update_email_template`,
          event: 'click',
          message: `Failed to update email template for id=${payload.id}`,
          status: `Failed to update email template`,
          action: `Clicked update email template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        yield put(showTemplateMessage(error?.response));
      }
    });
  }

  export function* getAppInstanceEmailTemplateList() {
    yield takeEvery(GET_APP_INSTANCE_EMAIL_TEMPLATE_LIST, function* ({ payload }) {
      const {query,appId,appInstanceId} = payload;
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      try {
        const response = yield axios.get(
          `${API_BASE_URL}/manage/instance-template?accountId=${accountId}&appId=${appId}&appInstanceId=${appInstanceId}&query=${
            query
          }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
          }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
          }`,
          config
        );
        if (response.status === 200) {
          if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_instance_email_templates`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and appInstanceId=${appInstanceId} and Keyword=${payload?.query}`,
                  status: `instance email templates retrieve successfully `,
                  action: `Search get instance email instance templatess`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
              const traceObj ={
                  type: `get_instance_email_templates`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and appInstanceId=${appInstanceId}`,
                  status: `instance email templatees retrieve successfully `,
                  action: `clicked get email templates`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
              }		
          yield put(instanceTemplates(response.data));
        }
      } catch (err) {
              if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_instance_email_templates`,
                  event: 'click',
                  message: `0 results found for keyword=${payload?.query} and accountId=${accountId} and appInstanceId=${appInstanceId}`,
                  status: `Failed to retrieve instance email templates`,
                  action: `Search tp get instance email templates`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
                  const traceObj ={
                  type: `get_instance_email_templates`,
                  event: 'click',
                  message: `0 results found for accountId=${accountId} and appInstanceId=${appInstanceId}`,
                  status: `Failed to retrieve instance email templates`,
                  action: `clicked get instance email templates`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }
              console.log(err);
              yield put(showTemplateMessage(err?.response));
      }
    });
  }
  
  export function* addAppInstanceEmailTemplate() {
      yield takeEvery(ADD_APP_INSTANCE_EMAIL_TEMPLATE, function* ({ payload }) {
        try {
          const accountId = localStorage.getItem("accountId");
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appInstanceId: localStorage.getItem("appInstanceId"),
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          const response = yield axios.post(
            `${API_BASE_URL}/manage/instance-template`,
            payload,
            config
          );
          if (response.status === 201) {
            const traceObj ={
              type: `add_instance_email_template`,
              event: 'click',
              message: `instance email template added successfully  for name=${payload?.name}`,
              status: `instance email template added successfully `,
              action: `Clicked instance email template to add`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
                const res = yield axios.get(
                  `${API_BASE_URL}/manage/instance-template?accountId=${accountId}&appInstanceId=${payload?.appInstanceId}&appId=${payload?.appId}&query=${
                    payload?.query
                  }&sortfield=${payload?.sorter?.field}&sortorder=${
                    payload?.sorter?.order
                  }&page=${payload?.pagination?.current - 1}&size=${
                    payload?.pagination?.pageSize
                  }`,
                  config
                );
                if (res.status === 200) {
                  Modal.success({
                    title: t("impaqx.adminApp.appInstanceEmailTemplateSuccessMessage"),
                    icon: <CheckCircleFilled />,
                    okText: t("impaqx.adminApp.close"),
                    //cancelText: 'Cancel',
                    onOk() {
                      //deleteApp(id);
                    },
                  });
                  yield put(instanceTemplates(res.data));
                  yield put(setAddEdit(false));
                }
              }
        } catch (err) {
          const traceObj ={
            type: `add_instance_email_template`,
            event: 'click',
            message: ` Failed to add instance email template name=${payload?.name}`,
            status: `Failed to add instance email template`,
            action: `Clicked instance email template to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(err);
          yield put(showTemplateMessage(err?.response));
        }
      });
    }
    
    export function* deleteAppInstanceEmailTemplate() {
      yield takeEvery(DELETE_APP_INSTANCE_EMAIL_TEMPLATE, function* ({ payload }) {
        try {
          const accountId = localStorage.getItem("accountId");
          const {appInstanceId}=payload;
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appInstanceId: localStorage.getItem("appInstanceId"),
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          const res = yield axios.delete(
            `${API_BASE_URL}/manage/instance-template/${payload?.id}`,
            config
          );
          if (res.status === 200) {
            const traceObj ={
              type: `delete_instance_email_template`,
              event: 'click',
              message: `instance email template deleted for id=${payload?.id}`,
              status: `instance email template deleted`,
              action: `Clicked delete instance email template`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
            //yield put(showAccountMessage(res));
            const res = yield axios.get(
                `${API_BASE_URL}/manage/instance-template?accountId=${accountId}&appInstanceId=${appInstanceId}&appId=${payload?.appId}&query=${
                  payload?.query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                  payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                  payload?.pagination?.pageSize
                }`,
                config
              );
              if (res.status === 200) {
                Modal.success({
                  title: t("impaqx.adminApp.appInstanceEmailTemplateDeleteMessage"),
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(instanceTemplates(res.data));
              }
          }
        } catch (error) {
          const traceObj ={
            type: `delete_instance_email_template`,
            event: 'click',
            message: `Failed to delete instance email template id=${payload.id}`,
            status: `Failed to delete instance email template`,
            action: `Clicked to delete instance email template`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          yield put(showTemplateMessage(error?.response));
        }
      });
    }
  
    export function* updateAppInstanceEmailTemplate() {
      yield takeEvery(UPDATE_APP_INSTANCE_EMAIL_TEMPLATE, function* ({ payload }) {
        const appEmailTemplate=payload;
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        try {
          const res = yield axios.put(
            `${API_BASE_URL}/manage/instance-template/${appEmailTemplate?.id}`,
            appEmailTemplate,
            config
          );
          if (res.status === 200) {
            const traceObj ={
                type: `update_instance_email_template`,
                event: 'click',
                message: `instance email template updated for id=${payload.id}`,
                status: `instance email template updated`,
                action: `Clicked to update instance email template`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                }; 
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
                const res = yield axios.get(
                    `${API_BASE_URL}/manage/instance-template?accountId=${appEmailTemplate?.accountId}&appInstanceId=${appEmailTemplate?.appInstanceId}&appId=${appEmailTemplate?.appId}&query=${
                      payload?.query
                    }&sortfield=${payload?.sorter?.field}&sortorder=${
                      payload?.sorter?.order
                    }&page=${payload?.pagination?.current - 1}&size=${
                      payload?.pagination?.pageSize
                    }`,
                    config
                  );
                  if (res.status === 200) {
                    Modal.success({
                      title: t("impaqx.adminApp.appInstanceEmailTemplateUpdateSuccessMessage"),
                      icon: <CheckCircleFilled />,
                      okText: t("impaqx.adminApp.close"),
                      //cancelText: 'Cancel',
                      onOk() {
                        //deleteApp(id);
                      },
                    });
                    yield put(instanceTemplates(res.data));
                    yield put(setAddEdit(false));
                  }
          }
        } catch (error) {
          const traceObj ={
            type: `update_instance_email_template`,
            event: 'click',
            message: `Failed to update instance email template for id=${payload.id}`,
            status: `Failed to update instance email template`,
            action: `Clicked update instance email template`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          yield put(showTemplateMessage(error?.response));
        }
      });
    }

export default function* rootSaga() {
    yield all([
      fork(getAppEmailTemplateList),
      fork(addAddAppEmailTemplate),
      fork(deleteAppEmailTemplate),
      fork(updateAppEmailTemplate),
      fork(getAppInstanceEmailTemplateList),
      fork(addAppInstanceEmailTemplate),
      fork(deleteAppInstanceEmailTemplate),
      fork(updateAppInstanceEmailTemplate)
    ]);
  }
  